module.exports = __webpack_public_path__ + "static/img/brees-2016-slide-6.eb7601e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2016-slide-6.jpg
// module id = emtJ
// module chunks = 1